export default class FontIconPointPlugin {
    afterInit(chart) {
        Chart.controllers.fontIconPoint = FontIconPointPluginDataSetController;
    }
}

class FontIconPointPluginDataSetController extends Chart.controllers.line {
    constructor(chart, datasetIndex) {
        super(chart, datasetIndex);
    }

    initialize(chart, datasetIndex) {
        super.initialize(chart, datasetIndex);
    }

    calculatePointY(value, index, datasetIndex) {
        return 20;
    }

    updateElement(point, index, reset) {
        super.updateElement(point, index, reset);

        let dataset = this.getDataset();
        let datasetIndex = this.index;
        let meta = this.getMeta();
        let xScale = this.getScaleForId(meta.xAxisID);
        let labels = this.chart.data.labels || [];
        let includeOffset = (labels.length === 1 || dataset.data.length === 1) || this.chart.isCombo;
        let value = dataset.data[index];

        //value was given with x and y coords
        if (typeof value === "object" &&
            value.hasOwnProperty("y")) {
            value = value["y"];
        }

        if (!value ||
            !value.text ||
            value.text === "") {
            return;
        }

        let pointOptions = this.chart.options.elements.fontIconPoint;

        point._model.x = xScale.getPixelForValue(0, index, datasetIndex, includeOffset);
        point._model.y = 20;

        point._model.value = value;
        point._model.index = index;
        point._model.processed = true;
        point._model.fontColor = (point.custom && point.custom.fontColor) || Chart.helpers.getValueAtIndexOrDefault(dataset.fontColor, index, pointOptions.fontColor);
        point._model.fontSize = ((point.custom && point.custom.pointRadius) || Chart.helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.pointRadius)) * 2;
        point._model.font = point._model.fontSize + "px " + ((point.custom && point.custom.font) || Chart.helpers.getValueAtIndexOrDefault(dataset.font, index, pointOptions.font));

        let maxGapSize = (point.custom && point.custom.maxGapSize) || Chart.helpers.getValueAtIndexOrDefault(dataset.maxGapSize, index, pointOptions.maxGapSize);

        //last shown icon
        let lastIcon = (this._lastVisiblePoint ? this._lastVisiblePoint.value.icon : null);

        //check if icon is same with last shown point
        let equalToLast = (index > 0) && (value.icon && lastIcon) && (value.icon === lastIcon);
        if (null === equalToLast) {
            equalToLast = false;
        }

        //calculate distance to last point
        let gapSize = maxGapSize;

        //if last point not available or position would be negative
        if (this._lastVisiblePoint &&
            point._model.x > 0 &&
            point._model.x >= this._lastVisiblePoint.x) {
            gapSize = (this._lastVisiblePoint ? point._model.x - this._lastVisiblePoint.x : maxGapSize);
        }

        //is it equal to last shown point and the distance to last is below max = no show
        let collapsed = equalToLast && (gapSize < maxGapSize);

        //if point does not have an icon, force no-show
        if ("" === value.icon) {
            collapsed = true;
        }

        point._model.equalToLast = equalToLast;

        if (!point._model.hasOwnProperty("collapsed") ||
            null === point._model.collapsed) {
            point._model.collapsed = collapsed;
        }

        //icon should not be rendered?
        if (collapsed) {
            point._model.radius = 2;

        //icon is rendered
        } else {
            point._model.collapsed = false;

            // hide last point if it was collapsable and too close
            if (this._lastVisiblePoint && this._lastVisiblePoint.equalToLast && (gapSize < maxGapSize)) {
                this._lastVisiblePoint.collapsed = true;
            }

            // cache current point as last visible point
            this._lastVisiblePoint = point._model;
        }

        point._model.drawCompositeOperation = (point.custom && point.custom.drawCompositeOperation) || Chart.helpers.getValueAtIndexOrDefault(dataset.drawCompositeOperation, index, pointOptions.drawCompositeOperation);
    }

    get dataElementType() {
        return FontIconPluginPoint;
    }

    setHoverStyle(point) {
        // Point
        let dataset = this.chart.data.datasets[point._datasetIndex];
        let index = point._index;
        let custom = point.custom || {};
        let model = point._model;

        let pointOptions = this.chart.options.elements.fontIconPoint;

        model.hover = true;
        model.fontColor = custom.hoverFontColor || Chart.helpers.valueAtIndexOrDefault(dataset.hoverFontColor, index, pointOptions.hoverFontColor);
        model.radius = custom.pointHoverRadius || Chart.helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, pointOptions.pointHoverRadius);
        model.fontSize = model.radius * 2;
        model.font = model.fontSize + "px " + (custom.font || Chart.helpers.valueAtIndexOrDefault(dataset.font, index, pointOptions.font));
        model.backgroundColor = custom.hoverBackgroundColor || Chart.helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, Chart.helpers.getHoverColor(model.backgroundColor));
        model.borderColor = custom.hoverBorderColor || Chart.helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, Chart.helpers.getHoverColor(model.borderColor));
        model.borderWidth = custom.hoverBorderWidth || Chart.helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
    }

    removeHoverStyle(point) {
        let dataset = this.chart.data.datasets[point._datasetIndex];
        let index = point._index;
        let custom = point.custom || {};
        let model = point._model;

        let pointOptions = this.chart.options.elements.fontIconPoint;

        // Compatibility: If the properties are defined with only the old name, use those values
        if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
            dataset.pointRadius = dataset.radius;
        }

        model.hover = false;
        model.fontColor = custom.fontColor || Chart.helpers.valueAtIndexOrDefault(dataset.fontColor, index, pointOptions.fontColor);
        model.radius = custom.radius || Chart.helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius);
        model.fontSize = model.radius * 2;
        model.font = model.fontSize + "px " + (custom.font || Chart.helpers.valueAtIndexOrDefault(dataset.font, index, pointOptions.font));
        model.backgroundColor = this.getPointBackgroundColor(point, index);
        model.borderColor = this.getPointBorderColor(point, index);
        model.borderWidth = this.getPointBorderWidth(point, index);
    }    
}

Chart.defaults._set('global', {
    elements: {
        fontIconPoint: {
            radius: 3,
            fontColor: '#333',
            font: "fontawesome",
            pointRadius: 8,
            pointHoverRadius: 12,
            maxGapSize: Number.MAX_VALUE,
            drawCompositeOperation: 'source-over',

            // Hover
            hitRadius: 3,
            hoverRadius: 6,
            hoverFontColor: '#000',
        }
    }
});

class FontIconPluginPoint extends Chart.elements.Point {
    constructor(configuration) {
        super(configuration);
    }

    tooltipPosition() {
        let vm = this._view;
        return {
            x: vm.x,
            y: vm.y + 10,
            padding: vm.radius + vm.borderWidth
        };
    }

    draw(chartArea) {
        //missing icon text?
        if (!this._model ||
            !this._model.value ||
            !this._model.value.text ||
            "undefined" === this._model.value.text) {
            return;
        }

        //is it collapsed and not currently hovered?
        if (this._model.collapsed && ! this._model.hover) {
            return;
        }

        let vm = this._view;
        let ctx = this._chart.ctx;

        if (vm.skip) {
            return;
        }

        ctx.textBaseline = 'middle';
        ctx.textAlign = "center";
        ctx.fillStyle = vm.fontColor || "grey";
        ctx.font = vm.font || "10px Arial";
        let comp = ctx.globalCompositeOperation;
        ctx.globalCompositeOperation = this._model.drawCompositeOperation;


        /*if (this._model.collapsed && ! this._model.hover) {
            ctx.fillText("·", this._model.x, this._model.y);
        } else {*/
            ctx.fillText(this._model.value.text, this._model.x, this._model.y);
        //}

        ctx.globalCompositeOperation = comp;
    }
}


// WEBPACK FOOTER //
// ./src/components/chart/plugins/FontIconPointPlugin.js